import React, { useEffect, useState } from 'react';
import { ApplicationState, AppThunkDispatch } from '../stores';
import { clearNotification } from '../stores/notification/actions';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, Fade } from '@material-ui/core';
import { Alert } from './alert';

const SNACKBAR_DURATION = 5000;
const TRANSITION_DURATION = 500;
const TRANSITION_COMPONENT = Fade;
const SUCCESS = 'success';
const ERROR = 'error';
const WARNING = 'warning';
const INFO = 'info';

function Notifier() {
  /*
We are copying success, warning, error and info messages to state to avoid flicker when
message is consumed and props come empty.
  */
  const successMsg = useSelector<ApplicationState, string | undefined>(
    state => state.notification.successMsg,
  );
  const errorMsg = useSelector<ApplicationState, string | undefined>(
    state => state.notification.errorMsg,
  );
  const warningMsg = useSelector<ApplicationState, string | undefined>(
    state => state.notification.warningMsg,
  );
  const infoMsg = useSelector<ApplicationState, string | undefined>(
    state => state.notification.infoMsg,
  );
  const dispatch = useDispatch<AppThunkDispatch>();

  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [stateSuccessMsg, setStateSuccessMsg] = useState<string>();
  const [showError, setShowError] = useState<boolean>(false);
  const [stateErrorMsg, setStateErrorMsg] = useState<string>();
  const [showWarning, setShowWarning] = useState<boolean>(false);
  const [stateWarningMsg, setStateWarningMsg] = useState<string>();
  const [showInfo, setShowInfo] = useState<boolean>(false);
  const [stateInfoMsg, setStateInfoMsg] = useState<string>();

  useEffect(() => {
    if (successMsg) {
      setShowSuccess(true);
      setStateSuccessMsg(successMsg);
    } else setShowSuccess(false);
  }, [successMsg]);

  useEffect(() => {
    if (errorMsg) {
      setShowError(true);
      setStateErrorMsg(errorMsg);
    } else setShowError(false);
  }, [errorMsg]);

  useEffect(() => {
    if (warningMsg) {
      setShowWarning(true);
      setStateWarningMsg(warningMsg);
    } else setShowWarning(false);
  }, [warningMsg]);

  useEffect(() => {
    if (infoMsg) {
      setShowInfo(true);
      setStateInfoMsg(infoMsg);
    } else setShowInfo(false);
  }, [infoMsg]);

  function consumeNotification(notificationChannel: string) {
    dispatch(clearNotification(notificationChannel));
  }

  return (
    <>
      <Snackbar
        open={showSuccess}
        autoHideDuration={SNACKBAR_DURATION}
        TransitionComponent={TRANSITION_COMPONENT}
        transitionDuration={TRANSITION_DURATION}
        onClick={() => consumeNotification(SUCCESS)}
        onClose={() => consumeNotification(SUCCESS)}
      >
        <Alert severity={SUCCESS}>{stateSuccessMsg}</Alert>
      </Snackbar>

      <Snackbar
        open={showError}
        autoHideDuration={SNACKBAR_DURATION}
        TransitionComponent={TRANSITION_COMPONENT}
        transitionDuration={TRANSITION_DURATION}
        onClick={() => consumeNotification(ERROR)}
        onClose={() => consumeNotification(ERROR)}
      >
        <Alert severity={ERROR}>{stateErrorMsg}</Alert>
      </Snackbar>

      <Snackbar
        open={showWarning}
        autoHideDuration={SNACKBAR_DURATION}
        TransitionComponent={TRANSITION_COMPONENT}
        transitionDuration={TRANSITION_DURATION}
        onClick={() => consumeNotification(WARNING)}
        onClose={() => consumeNotification(WARNING)}
      >
        <Alert severity={WARNING}>{stateWarningMsg}</Alert>
      </Snackbar>

      <Snackbar
        open={showInfo}
        autoHideDuration={SNACKBAR_DURATION}
        TransitionComponent={TRANSITION_COMPONENT}
        transitionDuration={TRANSITION_DURATION}
        onClick={() => consumeNotification(INFO)}
        onClose={() => consumeNotification(INFO)}
      >
        <Alert severity={INFO}>{stateInfoMsg}</Alert>
      </Snackbar>
    </>
  );
}

export default Notifier;
